
























import { Component, Vue, Watch } from "vue-property-decorator";

import PaginatedSearch from "@/layouts/DashboardLayoutComponents/SoniprevPaginatedSearch.vue";
import CreationCard from "@/layouts/DashboardLayoutComponents/CreationCard.vue";
import FormField from "@/layouts/DashboardLayoutComponents/FormField.vue";
import EntityModal from "@/layouts/DashboardLayoutComponents/EntityModal.vue";

import professionModel from "@/models/profession.model";
import specialtyModel from "@/models/specialty.model";
import sectorModel from "@/models/sector.model";

@Component({
	name: "users",
	components: {
		PaginatedSearch,
		CreationCard,
		FormField,
		EntityModal,
	},
})
export default class AdminServices extends Vue {
	modalKind: any = "";
	id: any;

	professionModel: any;
	professionCreationFields = [
		{ key: "name", class: "md-size-50" },
		{ key: "documentName", class: "md-size-50" },
	];
	professionModalFields = [
		{ icon: "edit", name: "Dados", fields: [
			{ key: "name", class: "md-size-50" },
			{ key: "documentName", class: "md-size-50" },
			{ key: "documentAttachmentName", class: "md-size-50" },
		]},
		{ icon: "delete", name: "Excluir", fields: [
			{ key: "name", class: "md-size-50", props: { disabled: true } },
			{ key: "documentName", class: "md-size-50", props: { disabled: true } },
		]},
	];

	specialtyModel: any;
	specialtyCreationFields = [
		{ key: "profession", class: "md-size-50", props: { manyToOneModel: professionModel }},
		{ key: "name", class: "md-size-50" },
	];
	specialtyModalFields = [
		{ icon: "edit", name: "Dados", fields: [
			{ key: "name", class: "md-size-50" },
			{ key: "profession.name", class: "md-size-50", props: { disabled: true } },
			{ key: "sectors", class: "md-size-50" },
		]},
		{ icon: "delete", name: "Excluir", fields: [
			{ key: "name", class: "md-size-50", props: { disabled: true } },
		]},
	];

	sectorModel: any;

	constructor() {
		super();
		this.professionModel = professionModel;
		this.specialtyModel = specialtyModel;
		this.sectorModel = sectorModel;
	}

	async mounted() {
		this.modalKind = this.$route.params.kind;
		this.id = this.$route.params.id;
	}

	@Watch("$route")
	updateRoute(route: any) {
		if (route.params.id) {
			this.modalKind = route.params.kind;
			this.id = route.params.id;
		} else {
			this.modalKind = "";
			this.id = "";
		}
	}

	//--- Profession
	openProfession(profession: any) {
		this.$router.push(`/administrativo/servicos/profissao/${profession.id}`);
	}

	closeProfession() {
		this.$router.push('..');
		(this.$refs.professionSearch as any).refresh();
	}

	//--- Specialty
	openSpecialty(specialty: any) {
		this.$router.push(`/administrativo/servicos/especialidade/${specialty.id}`);
	}

	closeSpecialty() {
		this.$router.push('..');
		(this.$refs.specialtySearch as any).refresh();
	}
}
